import SegmentedControl from "app/components/SegmentedControl/SegmentedControl";
import { useEffect, useState } from "react";
import { IntlShape } from "react-intl";
import "./SetYourLossLimit.scss";
type Props = {
  intl: IntlShape;
  handleChange: (id: string, value: string | number) => void;
};

export const LossLimitsTypes = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

const SetYourLossLimit = ({ intl, handleChange }: Props) => {
  const [tab, setTab] = useState(LossLimitsTypes.MONTHLY);
  const [isComponentLoaded, setIsComponentLoaded] = useState(false);
  const getTabs = () => {
    return [
      {
        title: intl.formatMessage({
          id: "home-register-limits-daily",
        }),
        callback: () => setTab(LossLimitsTypes.DAILY),
        isActive: tab === LossLimitsTypes.DAILY,
        id: "home-register-limits-daily",
      },
      {
        title: intl.formatMessage({
          id: "home-register-limits-weekly",
        }),
        callback: () => setTab(LossLimitsTypes.WEEKLY),
        isActive: tab === LossLimitsTypes.WEEKLY,
        id: "home-register-limits-weekly",
      },
      {
        title: intl.formatMessage({
          id: "home-register-limits-monthly",
        }),
        callback: () => setTab(LossLimitsTypes.MONTHLY),
        isActive: tab === LossLimitsTypes.MONTHLY,
        id: "home-register-limits-monthly",
      },
    ];
  };

  useEffect(() => {
    setIsComponentLoaded(true);
  }, []);

  useEffect(() => {
    isComponentLoaded && selectLossLimitsParameterName(tab);
  }, [tab]);

  const selectLossLimitsParameterName = (tab: string) => {
    if (tab === LossLimitsTypes.DAILY) {
      handleChange("lossLimits", "lossLimitOneDay");
    } else if (tab === LossLimitsTypes.WEEKLY) {
      handleChange("lossLimits", "lossLimitSevenDays");
    } else if (tab === LossLimitsTypes.MONTHLY) {
      handleChange("lossLimits", "lossLimitThirtyDays");
    }
  };

  return (
    <div className="form-details__row set-your-loss-limit">
      <label className="set-your-loss-limit__label">
        {intl.formatMessage({
          id: "home-register-limits-set-loss",
        })}
      </label>
      <SegmentedControl
        tabTypes={tab}
        tabs={getTabs()} // Pass the array of tabs
      />
    </div>
  );
};

export default SetYourLossLimit;
